import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["message"];

  connect() {
    this.animateIn();
  }

  animateIn() {
    this.messageTarget.classList.add("animate__animated", "animate__fadeInDown");

    setTimeout(() => {
      this.messageTarget.classList.remove("animate__fadeInDown");
      this.animateOut();
    }, 1000);
  }

  animateOut() {
    setTimeout(() => {
      this.messageTarget.classList.add("animate__fadeOutUp");
    }, 1000);
  }
}
